<script setup lang="ts">

import { useOnTimezoneChange } from '@entities/viewer'
import { LoaderBlock } from '@shared/ui/loaders'
import { CardAdmin } from '@shared/ui/cards'

import DisciplineStageLogItem from './DisciplineStageLogItem.vue'
import { useDisciplineStageLogs } from '../model/discipline-stage-logs.hook'

defineOptions({
  name: 'DisciplineStageLogs',
})

const {
  rows,
  isLoadingMore,
  kanbanPriority,
  fetchLogs,
} = useDisciplineStageLogs()

onMounted(() => {
  void fetchLogs()
})

// Row times arrive pre-shifted into the admin's view timezone.
useOnTimezoneChange(() => {
  void fetchLogs()
})
</script>

<template>
  <CardAdmin
    title="Log"
    class="discipline-stage-logs"
  >
    <div class="discipline-stage-logs__list">
      <DisciplineStageLogItem
        v-for="row in rows"
        :key="row.log.id"
        :row="row"
        :kanban-priority="kanbanPriority"
      />
      <div
        v-if="isLoadingMore"
        class="discipline-stage-logs__loader"
      >
        <LoaderBlock size="sm" />
      </div>
    </div>
  </CardAdmin>
</template>

<style scoped lang="scss" src="./DisciplineStageLogs.scss" />
